import MessageIcon from '@material-ui/icons/Message';
import { HandbookNotificationCreateView } from './views/handbook-notification-create.view';

export default {
  create: HandbookNotificationCreateView,
  icon: MessageIcon,
};
